import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeMasterFileLocation } from "../Entity/TreeNodeMasterFileLocation";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMasterFileLocationList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Master File Locations ({param})');
      this.labelNodeName = 'MAster File Locations';
      this.parent = parent;
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated = new TreeNodeMasterFileLocation(this.ioc!, this);
      if ((params.operationType===1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) {
        nodeCreated.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
      }
      this.children?.push(nodeCreated);
      this.refreshLabel();
      return [nodeCreated];
    }
      
    override getMessage(): any {
      let masterfilelocations: any[] = [];
      this.children?.forEach((node) => {
        let masterfilelocation = node as TreeNodeMasterFileLocation;
        let art57Message = masterfilelocation.getMessage();
        if (art57Message != null) {
          masterfilelocations.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return {
          masterfilelocations: { masterfilelocation: masterfilelocations },
        };
      } else {
        return;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'City', 'Country'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeMasterFileLocation = new TreeNodeMasterFileLocation(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }